import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch} from 'react-redux';
import {useHistory } from 'react-router-dom';
import { Loader } from 'rsuite';
import Carousel from 'react-material-ui-carousel';
import * as actionsAdmin  from '../../../../app/actions/admin';
import NewsBox  from './NewsBox';
import useWindowDimensions from "./hooks/useWindowDimensions";


const NewsMain = () => {

    const history = useHistory();
    const pathname = history?.location?.pathname;
    const isDetails = pathname.includes('news-details')

    const { height, width } = useWindowDimensions();

    const boxSize = width > 960 ? 3 : width > 670 ? 2 : 1;

    const dispatch = useDispatch();

    let {newsData} = useSelector(state => state.news);

    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        const fetchNews = async () => {
            setLoading(true);
            await dispatch(actionsAdmin.getNews());
            setLoading(false);
        }

        if(!newsData?.length) {
        //if(true) {
            fetchNews();
        }
    }, []);

    const renderNewsBoxes = () => {

        const newsMap = newsData.reduce((acc, newsObj, i) => {
            const accLen = acc.length;

            if(!accLen) return [[newsObj]];

            if(acc[accLen-1]?.length === boxSize) return [...acc, [newsObj]];

            acc[accLen-1].push(newsObj);

            return acc;
        }, [] );

        //console.log(newsMap);
        return newsMap.map((newsBox, i)=><NewsBox newsBox={newsBox} key={i+1} />)
    }

    renderNewsBoxes();

    return (
        <div>
            {!isDetails ? <h3>Новини</h3> : null}
        
            <Carousel>
                {renderNewsBoxes()}
            </Carousel>
            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}
        </div>

    )
}

export default NewsMain;